var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('div',{staticClass:"display-1 primary--text font-weight-light"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"caption primary--text font-weight-light"},[_vm._v(_vm._s(_vm.amount))]),_c('div',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }